const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneAlt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 4C3 14 9.99969 21 20 21",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0006 20.9978L20.4922 19.0301C20.6723 18.3099 20.7623 17.9498 20.7018 17.6274C20.6484 17.3433 20.5142 17.0807 20.3151 16.8711C20.0892 16.6333 19.7445 16.4954 19.0552 16.2197L17.4697 15.5855C16.9383 15.3729 16.6726 15.2667 16.4077 15.2585C16.1735 15.2513 15.941 15.2991 15.7286 15.3979C15.4883 15.5097 15.286 15.7121 14.8813 16.1168L11.7949 19.1546",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 4.00149L4.96733 3.50959C5.68758 3.32953 6.0477 3.23949 6.37009 3.30003C6.65417 3.35337 6.91678 3.48764 7.12635 3.68671C7.36417 3.91262 7.50204 4.25728 7.77776 4.94659L8.48846 6.72333C8.67477 7.18912 8.76793 7.42202 8.784 7.65774C8.79821 7.86633 8.76867 8.07558 8.69726 8.27207C8.61655 8.49413 8.46255 8.69214 8.15456 9.08813L5.11596 12.7283",
    stroke: "#1859FF",
    style: {
      stroke: "#1859FF",
      stroke: "color(display-p3 0.0941 0.3490 1.0000)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneAlt);
export default __webpack_public_path__ + "static/media/phone-alt.7183848cfd34823c5caf03e8291d9763.svg";
export { ForwardRef as ReactComponent };